/**
 * BASKETS & THINGS — base.js
 * Shopify core compatibility layer
 */
(function () {
  'use strict';

  // Accessibility: focus management
  document.querySelectorAll('.focus-none').forEach(el => {
    el.addEventListener('focus', e => e.target.removeAttribute('tabindex'));
  });

  // Lazy-load images
  if ('IntersectionObserver' in window) {
    const lazyImgs = document.querySelectorAll('img[loading="lazy"]');
    const imgObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImgs.forEach(img => imgObserver.observe(img));
  }

  // Announce page transitions for screen readers
  const a11yMsg = document.getElementById('a11y-refresh-page-message');
  if (a11yMsg) {
    document.addEventListener('page:loaded', () => {
      a11yMsg.textContent = a11yMsg.textContent;
    });
  }
})();
